<div class="holder">
    <label *ngIf="label" for="">{{label}}</label>
    <input [attr.type]="type">
</div>
